import * as yup from "yup";
import {
  createBaseUserEmailValidationSchema,
  createBaseUsernameValidationSchema,
  createBaseUserValidationSchema,
} from "../users/userValidationSchema";
import { createPasswordConfirmationValidationSchema } from "../password/base/passwordConfirmationValidationSchema";
import { initializeYup } from "@duosoftbg/nacid-components";

export const createRegistrationValidationSchema = () => {
  initializeYup(yup);

  const registrationValidationSchema = yup
    .object()
    .concat(createPasswordConfirmationValidationSchema())
    .concat(createBaseUserEmailValidationSchema())
    .concat(createBaseUsernameValidationSchema())
    .concat(createBaseUserValidationSchema());

  return registrationValidationSchema;
};
